import React from "react";

interface ArrowRightIconProps {
  size?: string | number;        // width/height
  color?: string;       // arrow color
  style?: React.CSSProperties;
}

/**
 * SVG arrow icon pointing to the right.
 */
export const ArrowRightIcon: React.FC<ArrowRightIconProps> = (
  {
    size = 12,
    color = "currentColor",
    style
  }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{display: "inline-block", verticalAlign: "middle", margin: "0 3px", ...style}}
  >
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);
